module.exports = __webpack_public_path__ + "54ba62bbc41824813fe4f50316a3f13e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/ita.svg
// module id = 59
// module chunks = 0